import { render, staticRenderFns } from "./EntryMain.vue?vue&type=template&id=6516bd75&scoped=true&"
import script from "./EntryMain.vue?vue&type=script&lang=js&"
export * from "./EntryMain.vue?vue&type=script&lang=js&"
import style0 from "./EntryMain.vue?vue&type=style&index=0&id=6516bd75&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6516bd75",
  null
  
)

export default component.exports